const phoneHelper = (() => {
  const countryPrefixMap = {
    IE: '+353',
    GB: '+44',
    AU: '+61',
    AT: '+43',
    CN: '+86',
    DE: '+49',
    HK: '+852',
    IT: '+39',
    JP: '+81',
    NL: '+31',
    NZ: '+64',
    SG: '+65',
    ZA: '+27',
    ES: '+34',
    CH: '+41'
  };

  function availablePrefixes() {
    return [
      { key: '+353', value: 'Ireland (00353)' },
      { key: '+44', value: 'United Kingdom (0044)' },
      { key: '+61', value: 'Australia (0061)' },
      { key: '+43', value: 'Austria (0043)' },
      { key: '+86', value: 'China (0086)' },
      { key: '+49', value: 'Germany (0049)' },
      { key: '+852', value: 'Hong Kong (00852)' },
      { key: '+39', value: 'Italy (0039)' },
      { key: '+81', value: 'Japan (0081)' },
      { key: '+31', value: 'Netherlands (0031)' },
      { key: '+64', value: 'New Zealand (0064)' },
      { key: '+65', value: 'Singapore (0065)' },
      { key: '+27', value: 'South Africa (0027)' },
      { key: '+34', value: 'Spain (0034)' },
      { key: '+41', value: 'Switzerland (0041)' }
    ];
  }

  function prefixFromCountryCode(countryCode) {
    if (!countryCode || typeof countryCode !== 'string') {
      return null;
    }
    const code = countryCode.trim().toUpperCase();
    return countryPrefixMap[code] || null;
  }

  function splitPhoneNumber(phone) {
    if (!phone || typeof phone !== 'string' || !phone.trim()) {
      return { prefix: null, number: null };
    }

    // Normalize spaces
    phone = phone.replace(/\s+/g, ' ').trim();

    // Normalize leading symbols to always start with +
    if (phone.startsWith('00')) {
      phone = `+${phone.slice(2)}`;
    }

    // Remove internal spaces for matching
    const clean = phone.replace(/\s+/g, '');

    // Sort prefixes by length (longest first)
    const prefixes = availablePrefixes()
      .map((p) => p.key)
      .sort((a, b) => b.length - a.length);

    // Find matching prefix (longest match wins)
    const match = prefixes.find((p) => clean.startsWith(p));

    if (match) {
      const number = clean.slice(match.length);
      return {
        prefix: match,
        number: number || null
      };
    }

    // Fallback: check if number starts with numeric version of known prefix
    const matchNumeric = prefixes.find((p) =>
      clean.startsWith(p.replace('+', ''))
    );

    if (matchNumeric) {
      const prefixDigits = matchNumeric.replace('+', '');
      const number = clean.slice(prefixDigits.length);
      return {
        prefix: `+${prefixDigits}`,
        number: number || null
      };
    }

    // No match found → return cleaned input
    return { prefix: null, number: clean || null };
  }

  return {
    availablePrefixes,
    prefixFromCountryCode,
    splitPhoneNumber
  };
})();

export default phoneHelper;
